import { useTransition } from "react";
import { useOrganizationList } from "@clerk/react";
import { toast } from "sonner";
import { Icone } from "@/components/Icone";
import { arquivarClinicaAction, entrarComoAdminAction, excluirClinicaAction, restaurarClinicaAction } from "@/web/src/acoes-config";

export function AcoesClinica({
  id,
  slug,
  nome,
  status,
  ativa,
}: {
  id: string;
  slug: string;
  nome: string;
  status: "ativo" | "arquivado";
  ativa: boolean;
}) {
  const [pendente, iniciar] = useTransition();
  const { setActive } = useOrganizationList();

  const acao =
    "flex h-8 items-center gap-1.5 rounded-full px-3 text-[13px] font-semibold transition-colors disabled:opacity-40";

  return (
    <div className="flex justify-end gap-1">
      {!ativa && (
        <button
          type="button"
          disabled={pendente}
          onClick={() =>
            iniciar(async () => {
              const r = await entrarComoAdminAction(id);
              if (!r.ok) {
                toast.error(r.erro);
                return;
              }
              if (!setActive) return;
              await setActive({ organization: id });
              window.location.href = "/conversas";
            })
          }
          className={`${acao} text-[var(--color-suave)] hover:bg-[var(--color-realce)] hover:text-[var(--color-marca-forte)]`}
        >
          <Icone nome="entrar" className="h-3.5 w-3.5" /> Entrar
        </button>
      )}

      {status === "ativo" ? (
        <button
          type="button"
          disabled={pendente}
          onClick={() => {
            if (!confirm(`Arquivar ${nome}? Ela para de responder no WhatsApp, mas o cadastro fica.`)) return;
            iniciar(async () => {
              const r = await arquivarClinicaAction(slug);
              if (!r.ok) toast.error(r.erro);
              else toast.success(`${nome} arquivada — para de responder.`);
            });
          }}
          className={`${acao} text-[var(--color-suave)] hover:bg-[var(--color-painel)] hover:text-[var(--color-tinta)]`}
        >
          <Icone nome="arquivar" className="h-3.5 w-3.5" /> Arquivar
        </button>
      ) : (
        <>
          <button
            type="button"
            disabled={pendente}
            onClick={() =>
              iniciar(async () => {
                const r = await restaurarClinicaAction(slug);
                if (!r.ok) toast.error(r.erro);
                else toast.success(`${nome} de volta.`);
              })
            }
            className={`${acao} text-[var(--color-suave)] hover:bg-[var(--color-realce)] hover:text-[var(--color-marca-forte)]`}
          >
            <Icone nome="restaurar" className="h-3.5 w-3.5" /> Restaurar
          </button>
          <button
            type="button"
            disabled={pendente}
            onClick={() => {
              if (!confirm(`Excluir ${nome} de vez? Conversas, fichas e conexão somem do banco. A organização no Clerk continua.`)) return;
              iniciar(async () => {
                const r = await excluirClinicaAction(slug);
                if (!r.ok) toast.error(r.erro);
                else toast.success("Excluída.");
              });
            }}
            className={`${acao} text-[var(--color-fraco)] hover:bg-[var(--color-alerta)]/10 hover:text-[var(--color-alerta)]`}
          >
            <Icone nome="lixeira" className="h-3.5 w-3.5" /> Excluir
          </button>
        </>
      )}
    </div>
  );
}
